module.exports = __webpack_public_path__ + "img/vw-header-banner.19bbf55b.png";